<template>
  <div class="my-3 mr-md-0 mr-3">
    <LocationNew
      v-if="locationFormat === 0"
      :home="home"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationNew"
    ></LocationNew>
    <LocationExisting
      v-else-if="locationFormat === 1"
      :home="home"
      :projectId="projectId"
      :datasheetId="datasheetId"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationExisting"
    ></LocationExisting>
    <LocationBoth
      v-else-if="locationFormat === 2"
      :home="home"
      :projectId="projectId"
      :datasheetId="datasheetId"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationBoth"
    ></LocationBoth>
    <div v-else>This Datasheet does not require a location</div>
  </div>
</template>
<script>
import LocationNew from "./locationNew.vue";
import LocationExisting from "./locationExisting.vue";
import LocationBoth from "./locationBoth.vue";

export default {
  name: "DatasheetLocationSelector",
  components: {
    LocationNew,
    LocationExisting,
    LocationBoth,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    locationFormat: {
      type: Number,
      default: 3,
    },
    home: {
      type: Object,
      default: null,
    },
    datasheetId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    updateInput(location) {
      this.$emit("input", location);
    },
    validate() {
      if (this.$refs.locationNew && this.$refs.locationNew.validateLocation) {
        return this.$refs.locationNew.validateLocation();
      } else if (
        this.$refs.locationExisting &&
        this.$refs.locationExisting.validateLocation
      ) {
        return this.$refs.locationExisting.validateLocation();
      } else if (
        this.$refs.locationBoth &&
        this.$refs.locationBoth.validateLocation
      ) {
        return this.$refs.locationBoth.validateLocation();
      } else {
        return Promise.resolve(true);
      }
    },
  },
};
</script>
<style lang="css" scoped></style>
